var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.5C11.846 18.5 13.543 17.865 14.897 16.812L19.293 21.208L20.707 19.794L16.311 15.398C17.365 14.043 18 12.346 18 10.5C18 6.089 14.411 2.5 10 2.5C5.589 2.5 2 6.089 2 10.5C2 14.911 5.589 18.5 10 18.5ZM10 4.5C13.309 4.5 16 7.191 16 10.5C16 13.809 13.309 16.5 10 16.5C6.691 16.5 4 13.809 4 10.5C4 7.191 6.691 4.5 10 4.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4118 9.08511C11.7908 9.46511 11.9998 9.96711 11.9998 10.4991H13.9998C13.9998 9.43411 13.5838 8.43011 12.8258 7.67111C11.3118 6.15911 8.68683 6.15911 7.17383 7.67111L8.58583 9.08711C9.34583 8.32911 10.6558 8.33111 11.4118 9.08511Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSearch);
export default __webpack_public_path__ + "static/media/white-search.040fc631986dbfbcde91cd5a27a235c9.svg";
export { ForwardRef as ReactComponent };